import React, {Fragment} from 'react';
import _ from 'lodash';
import {Grid} from '@material-ui/core';
import NoQuotes from '../ChangeDealStatusModal/NoQuotes';
import ModalLoanItem from '../ChangeDealStatusModal/ModalLoanItem';
class StepOne extends React.Component {
  isSelected = (selectedLoanIds,id) => {
    return _.findIndex(selectedLoanIds,  x=> x === id) !== -1;
  }
  getSelectedCount = () => {
    return this.props.selectedLoanIds.length;
  }
  isMaxQuotesSelected = () => {
    return this.getSelectedCount() >= 1
  }
  renderLoans = (loans) => {    
    const {selectedLoanIds, onToggle} = this.props;            
    return loans.map( x=> (
      <ModalLoanItem 
        key={x.id}
        toggle={onToggle} 
        loan={x} 
        isSelected={this.isSelected(selectedLoanIds, x.id)}/>
      )
    );
  }
  render(){
    const {loans} = this.props;    
    return (
      <Fragment>
      {_.isEmpty(loans) && <NoQuotes/>}
      <Grid container direction="row" spacing={8}>
        {this.renderLoans(loans)}
      </Grid> 
      </Fragment>
    )
  }
}

export default StepOne;